import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {clearDb} from '../db'
import {clearLogoutPending, waitForBootLogout} from '../../lib/auth/logout_pending'

import {
  doAUTH_SET,
  doSETTINGS_SET,
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doPROJECT_SETTINGS_LIST_SET,
  doFAVORITE_LIST_SET,
  doIDENTITY_SET,
  doPROFILE_SET,
} from '../state'

export const REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT = 'REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT'
export const doREQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT = createDoRequestAction(
  REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT,
)

export const requestIdentityMfaVerificationCodeSubmitActionCreators = {
  doREQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT,
}

export function* identityMfaVerificationCodeSubmit({payload, setRequestResult}: any): SagaIterator {
  debug('saga*identityMfaVerificationCodeSubmit')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        email: v
          .string()
          .email({tlds: {allow: false}})
          .exist(),
        verificationCode: v.string().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {email, verificationCode} = payload

  // same wait as the password login -- a boot-time logout retry still in flight would
  // otherwise clear the cookie this request is about to set
  yield call(waitForBootLogout)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-mfa-verification-code-submit`,
    data: {
      email,
      verificationCode,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-mfa-verification-code-submit',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {
    profile,
    settings,
    projectSettingsList,
    workspaceFavoriteList,
    accessToken,
    accessTokenExpiresInSeconds,
    refreshTokenExpiresInSeconds,
    identity,
  } = result.payload

  // Ensure any stale local state is cleared before establishing a new session
  yield call(clearDb)

  yield put(
    doAUTH_SET({
      accessToken,
      accessTokenExpiresInSeconds,
      refreshTokenExpiresInSeconds,
    }),
  )

  // the marker retires on a successful login, the same as on the password path
  yield call(clearLogoutPending)

  yield put(doPROFILE_SET(profile || {}))
  yield put(doSETTINGS_SET(settings))
  yield put(doPROJECT_SETTINGS_LIST_SET(projectSettingsList))
  yield put(doFAVORITE_LIST_SET(workspaceFavoriteList))
  yield put(doIDENTITY_SET(identity))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* identityMfaVerificationCodeSubmitSaga() {
  yield takeEvery(REQUEST_IDENTITY_MFA_VERIFICATION_CODE_SUBMIT, identityMfaVerificationCodeSubmit)
}
